import { AskAIType } from "@/utils/streamFetch";

const allowedImageType: string[] = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/tiff",
  "image/webp",
];

const allowedAudioType: string[] = [
  "audio/mpeg",
  "audio/wav",
  "audio/aac",
  "audio/flac",
  "audio/ogg",
  "audio/x-ms-wma",
  "audio/mp4",
  "audio/m4a",
  "audio/x-m4a",
];

const allowedVideoType: string[] = [
  "video/mp4",
  "video/x-msvideo",
  "video/x-matroska",
  "video/quicktime",
  "video/x-ms-wmv",
  "video/x-flv",
  "video/webm",
  "video/mpeg",
  "video/avi",
];

const allowedExtraFileType: string[] = [
  ".aac",
  ".flv",
  ".pdf",
  ".odt",
  ".docx",
  ".odp",
  ".pptx",
  ".ods",
  ".xlsx",
  ".xls",
  ".csv",
  ".txt",
  ".rtf",
  ".md",
  ".xml",
];

export const AllowedAccept: string = [
  ...allowedImageType,
  ...allowedAudioType,
  ...allowedVideoType,
  ...allowedExtraFileType,
].join(", ");

export const getAskAIType = (
  type: string,
  name: string
): AskAIType | undefined => {
  const suffix = /(\.[^\.]+)/.exec(name)?.[1];

  if (!!suffix && allowedExtraFileType.includes(suffix)) return "FILE";

  return allowedAudioType.includes(type)
    ? "VOICE"
    : allowedImageType.includes(type)
    ? "IMAGE"
    : allowedVideoType.includes(type)
    ? "VIDEO"
    : void 0;
};
